import { Injectable, inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SecurityService } from '../security/security.service';

@Injectable({ providedIn: 'root' })
class DefaultPasswordGuardService {
  private router = inject(Router);
  private securityService = inject(SecurityService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.securityService.usuarioLogged;

    // Si no está autenticado, dejar pasar (authGuard se encargará)
    if (!user || !user.id) {
      return true;
    }

    // Si tiene contraseña por defecto
    if (user.is_default_password === 1 || user.is_default_password === true) {
      // Permitir acceso solo a la ruta de cambio obligatorio
      if (state.url.includes('/auth/change-password-required')) {
        return true;
      }

      console.log('🔒 DefaultPasswordGuard - Usuario con contraseña por defecto detectado');
      console.log('🔒 DefaultPasswordGuard - Redirigiendo a cambio obligatorio');

      // Guardar returnUrl para después del cambio
      sessionStorage.setItem('postPasswordChangeReturnUrl', state.url);

      // Redirigir a cambio obligatorio
      this.router.navigate(['/auth/change-password-required']);
      return false;
    }

    // Usuario sin contraseña por defecto, permitir acceso
    return true;
  }
}

export const defaultPasswordGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(DefaultPasswordGuardService).canActivate(route, state);
};
